import { render, staticRenderFns } from "./AddEventType.vue?vue&type=template&id=0c5f0026&"
import script from "./AddEventType.vue?vue&type=script&lang=js&"
export * from "./AddEventType.vue?vue&type=script&lang=js&"
import style0 from "./AddEventType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports